import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useAppSelector } from "appRedux/hooks"
import { useLazyGetFollowingsQuery, userProfileApi } from "appRedux/slices/userApiSlice"
import { updateFollowingsTab } from "appRedux/slices/profileTabsSlice"

export default function useFollowings(id?: number) {
  const cachedFollowings = useAppSelector((state) => id ? userProfileApi.endpoints.getFollowings.select(id)(state) : null)

  const [triggerGetFollowings, getFollowingsResult] = useLazyGetFollowingsQuery()

  const dispatch = useDispatch()

  useEffect(() => {
    if (cachedFollowings?.data) {
      dispatch(updateFollowingsTab(cachedFollowings?.data?.users || []))
      return
    }
    fetchFollowings()
  }, [id])

  function fetchFollowings() {
    if (!id) return
    triggerGetFollowings(id)
  }

  return {
    followings: cachedFollowings?.data?.users || getFollowingsResult?.data?.users || [],
    isFetching: getFollowingsResult.isFetching,
    isError: getFollowingsResult.isError
  }
}
